import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {
  CoordinateBancarie,
  Immobile,
  ISEE,
  Persona,
  Preferiti,
  ResidenzaDomicilio
} from "../models/preferiti";
import {Allegato} from "../models/integrazione";

@Injectable({
  providedIn: 'root'
})
export class PreferitiService {
  url = "services/portaleamministrazione/api"

  constructor(private httpClient: HttpClient) { }

  getSezioni(): Observable<string[]>{
    return this.httpClient.get<string[]>(this.url + '/pr-entita-gestione-pre');
  }

  getPreset(): Observable<Preferiti>{
    return this.httpClient.get<Preferiti>(this.url + '/preset');
  }

  updatePreferiti(): Observable<HttpResponse<any>>{
    return this.httpClient.post<HttpResponse<any>>(this.url + '/updatePreferiti', { observe: 'response' });
  }

  deletePersona(idPersona: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-persona-fisicas/' + idPersona);
  }

  modificaPersona(persone: Persona[]): Observable<any>{
    return this.httpClient.post<any>(this.url + '/list-pr-persona-fisicas', persone);
  }

  modificaImmobile(immobili: Immobile[]): Observable<any>{
    return this.httpClient.post<any>(this.url + '/list-pr-immobili', immobili);
  }

  modificaConiuge(coniuge: Persona): Observable<any>{
    return this.httpClient.post<any>(this.url + '/pr-persona-fisicas', coniuge);
  }

  modificaISEE(isee: ISEE): Observable<any>{
    return this.httpClient.post<any>(this.url + '/pr-isees', isee);
  }

  modificaIndirizzo(indirizzo: ResidenzaDomicilio): Observable<any>{
    return this.httpClient.post<any>(this.url + '/pr-indirizzos', indirizzo);
  }

  modificaCoordinateBancarie(cb: CoordinateBancarie): Observable<any>{
    return this.httpClient.post<any>(this.url + '/pr-coordinate-bancaries', cb);
  }

  modificaAllegati(allegati: Allegato): Observable<any>{
    return this.httpClient.post<any>(this.url + '/pr-allegatoes', allegati);
  }

  deleteAllegato(id: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-allegatoes/' + id);
  }

  deleteCoordinate(id: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-coordinate-bancaries/' + id);
  }

  deleteISEE(id: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-isees/' + id);
  }

  deleteIndirizzo(id: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-indirizzos/' + id);
  }

  deleteImmobile(id: string): Observable<any>{
    return this.httpClient.delete<any>(this.url + '/pr-immobili/' + id);
  }
}
